module.exports = __webpack_public_path__ + "img/card_title.270ed958.png";